import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Paper from "@mui/material/Paper";

export default function EvvSearcher() {
    return (
        <Paper
            component="form"
            sx={{display: 'flex', alignItems: 'center'}}
        >
            <IconButton aria-label="menu">
                <SearchIcon/>
            </IconButton>
            <InputBase
                fullWidth
                size="small"
                sx={{ml: 1, flex: 1}}
                placeholder="Search Employees"
                inputProps={{'aria-label': 'search google maps'}}
            />
        </Paper>
    );
}